import { render, staticRenderFns } from "./PointInquiry.vue?vue&type=template&id=68858d83&scoped=true"
import script from "./PointInquiry.vue?vue&type=script&lang=js"
export * from "./PointInquiry.vue?vue&type=script&lang=js"
import style0 from "./PointInquiry.vue?vue&type=style&index=0&id=68858d83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68858d83",
  null
  
)

export default component.exports